export default __webpack_public_path__ + "static/media/sec_slogan.db3e2eb0.png";